// extracted by mini-css-extract-plugin
export default {"modalCostosCarteleria":"CarteleriaCostosModal_modalCostosCarteleria__weTH9"};